import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";

export default function LeaderboardUnlockOverlay({
  count,
  onMaybeLater,
  onStartFreeTrial,
  onSubscribe,
  showStartFreeTrial = false,
}) {
  return (
    <div className="relative mt-2 overflow-hidden rounded-lg bg-white">
      {/* Faded, blurred backdrop */}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0">
        <div className="absolute -left-10 top-1/4 h-64 w-40 rounded-full bg-indigo-200/60 blur-3xl" />
        <div className="absolute left-1/3 top-0 h-48 w-1/2 rounded-full bg-amber-100/70 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 h-48 w-1/3 rounded-full bg-lime-100/60 blur-3xl" />
        <div className="absolute inset-0 bg-gradient-to-b from-white/70 via-white/30 to-white/70 backdrop-blur-sm" />
      </div>

      <div className="relative flex flex-col items-center px-4 py-16 text-center md:py-24">
        <FontAwesomeIcon icon={faLock} className="h-8 w-8 text-black" />
        <p className="mt-4 text-sm uppercase text-black">
          Unlock the full leaderboard
        </p>
        <h2 className="mt-1 text-2xl font-semibold text-red-500 md:text-3xl">
          Get the Complete Rankings
        </h2>
        <p className="mt-2 max-w-xl text-sm text-black">
          {`You're viewing the top ${count} ${count === 1 ? "athlete" : "athletes"}. `}
          See all athletes, compare performance, use filters, and explore every
          event.
        </p>

        <div className="mt-6 flex w-full flex-col justify-center gap-3 sm:w-auto sm:flex-row">
          <button
            type="button"
            onClick={onMaybeLater}
            className="rounded-md border border-gray-300 bg-white px-6 py-3 text-sm text-gray-600 transition hover:bg-gray-50 sm:min-w-32"
          >
            Maybe Later
          </button>

          {showStartFreeTrial && (
            <button
              type="button"
              onClick={onStartFreeTrial}
              className="rounded-md border border-red-200 bg-white px-6 py-3 text-sm text-red-500 transition hover:bg-red-50 sm:min-w-40"
            >
              Start 7 days Free Trial
            </button>
          )}

          <button
            type="button"
            onClick={onSubscribe}
            className="rounded-md bg-red-500 px-6 py-3 text-sm text-white transition hover:bg-red-600 sm:min-w-32"
          >
            Subscribe Now
          </button>
        </div>
      </div>
    </div>
  );
}
